import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';
import { $getSelection, $isRangeSelection } from 'lexical';
import {
  $getTableCellNodeFromLexicalNode,
  $isTableCellNode,
  $isTableSelection,
} from '@lexical/table';

export function TableCellSelectionPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    const removeUpdateListener = editor.registerUpdateListener(
      ({ editorState }) => {
        editorState.read(() => {
          const selection = $getSelection();

          // Clear all previous selection highlights
          const allCells = document.querySelectorAll('.lexical-table-cell');
          allCells.forEach((cell) => {
            cell.classList.remove('lexical-table-cell-selected');
          });

          // Handle table selection (multi-cell)
          if ($isTableSelection(selection)) {
            const nodes = selection.getNodes();
            nodes.forEach((node) => {
              const cellNode = $getTableCellNodeFromLexicalNode(node);
              if (cellNode && $isTableCellNode(cellNode)) {
                const cellDom = editor.getElementByKey(cellNode.getKey());
                if (cellDom) {
                  cellDom.classList.add('lexical-table-cell-selected');
                }
              }
            });
          }
          // Handle range selection within a single cell
          else if ($isRangeSelection(selection)) {
            const anchorNode = selection.anchor.getNode();
            const cellNode = $getTableCellNodeFromLexicalNode(anchorNode);
            if (cellNode && $isTableCellNode(cellNode)) {
              const cellDom = editor.getElementByKey(cellNode.getKey());
              if (cellDom && selection.isCollapsed()) {
                // Only highlight if not selecting text within cell
                cellDom.classList.add('lexical-table-cell-selected');
              }
            }
          }
        });
      },
    );

    return () => {
      removeUpdateListener();
    };
  }, [editor]);

  return null;
}
